import { gql, useMutation } from '@apollo/client';

const DELETE_RECORD_ENTRY = gql`
  mutation deleteRecordEntry($sourceId: ObjectId!, $groupId: ObjectId!) {
    deleteRecordEntry(sourceId: $sourceId, groupId: $groupId) {
      _id
    }
  }
`;

export const useDeleteRecordEntry = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteRecordEntry] = useMutation(DELETE_RECORD_ENTRY, { onCompleted: onSuccess });

  return {
    deleteRecordEntry: (groupId: string, sourceId: string) =>
      deleteRecordEntry({ variables: { groupId, sourceId } }),
  };
};
